// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import MarketingFact from '../../data/marketing/MarketingFact';
import timeIcon from '../../../../img/marketingIcon/sc_ma_visit-time.png';
import peopleIcon from '../../../../img/factIcon/people.png';
import basketIcon from '../../../../img/marketingIcon/sc_ma_spending-basket.png';
import weightSpendIcon from '../../../../img/factIcon/sc_fa_stores.png';

import KeyFigureTile from './components/KeyFigureTile';
import type { CentreTradeArea, KeyFigureType } from '../../../../types/marketingType';
import {
  autoQuantityCurrencyString,
  autoQuantityMinutesString,
  autoQuantityString,
} from '../../../../utils/formatUtils';
import Loader from '../../../common/Loader';
import MarketingEmptyTile from './MarketingEmptyTile';

type Props = {
  isKeyFiguresLoading: boolean,
  keyFigures: KeyFigureType,
  centreTradeArea: CentreTradeArea[],
};

function KeyFigures(props: Props) {
  let totalPopulation = null;
  if (props.isKeyFiguresLoading) {
    return (
      <Loader isLoading />
    );
  }
  if (!props.keyFigures || props.keyFigures.year === 0) {
    return (
      <MarketingEmptyTile errorMessage="MKT_PAGE.key_figures.NO_DATA" />
    );
  }
  if (props.centreTradeArea) {
    const totalTradeArea = props.centreTradeArea.find(tradeArea => tradeArea.tradeArea === 'Total Trade Area');
    totalPopulation = totalTradeArea ? totalTradeArea.population : null;
  }
  return (
    <div className="marketing-key-figure">
      {
        props.keyFigures.dwellTime && (
          <MarketingFact
            image={timeIcon}
            value={autoQuantityMinutesString(props.keyFigures.dwellTime)}
            label={<Translate value="MKT_PAGE.key_figures.tooltip.dwell_time" />}
            showTooltip
            tooltipContent={<Translate value="MKT_PAGE.key_figures.tooltip.dwell_time_content" />}
          />
        )
      }
      <div className="key-figure-tile-container">
        <KeyFigureTile
          image={peopleIcon}
          label={<Translate value="MKT_PAGE.key_figures.totalPopulation" />}
          tooltip={<Translate value="MKT_PAGE.key_figures.tooltip.total_population_content" />}
          value={autoQuantityString(totalPopulation)}
        />
        {
          props.keyFigures.averageSpendBasket && (
            <KeyFigureTile
              image={basketIcon}
              label={<Translate value="MKT_PAGE.key_figures.spendBasket" />}
              tooltip={<Translate value="MKT_PAGE.key_figures.tooltip.average_spend_basket_content" />}
              value={autoQuantityCurrencyString(props.keyFigures.averageSpendBasket, 0)}
            />
          )
        }
        <KeyFigureTile
          image={weightSpendIcon}
          label={<Translate value="MKT_PAGE.key_figures.weighedSpendPotential" />}
          tooltip={<Translate value="MKT_PAGE.key_figures.tooltip.total_weighed_sp_content" />}
          value={autoQuantityCurrencyString(props.keyFigures.totalWeightedSpendPotential)}
        />
        {/* TODO : reactivate when new marketing api is available */}
        {/* <KeyFigureTile */}
        {/*  image={loyaltyIcon} */}
        {/*  label={<Translate value="MKT_PAGE.key_figures.loyaltyCard" />} */}
        {/*  tooltip={<Translate value="MKT_PAGE.key_figures.tooltip.loyalty_cards_content" />} */}
        {/*  value={splitThousand(props.keyFigures.loyaltyNumber)} */}
        {/* /> */}
        {/* <KeyFigureTile */}
        {/*  image={websiteIcon} */}
        {/*  label={<Translate value="MKT_PAGE.key_figures.websiteUniqueVisitors" />} */}
        {/*  tooltip={<Translate value="MKT_PAGE.key_figures.tooltip.website_unique_visitors_content" />} */}
        {/*  value={splitThousand(props.keyFigures.websiteVisitor)} */}
        {/* /> */}
        {/* <KeyFigureTile */}
        {/*  image={websiteIcon} */}
        {/*  label={<Translate value="MKT_PAGE.key_figures.appDownloaded" />} */}
        {/*  tooltip={<Translate value="MKT_PAGE.key_figures.tooltip.app_downloaded_content" />} */}
        {/*  value={splitThousand(props.keyFigures.appDownloaded)} */}
        {/* /> */}
      </div>
    </div>
  );
}

export default KeyFigures;
